import { TFunction } from 'i18next';
import { User } from '../../../../contexts/LicenseManagementContext/LicenseManagementContext.types';
import { ADMIN_ROLE_NAME, AUTHOR_ROLE_NAME } from '../roles';

export const isUserDeletable = (
    u: User,
    selfId: string | undefined,
    t: TFunction,
    rmEnabled: boolean | undefined, // can be removed once RM is released
) => {
    const roleNames = (u.roles || []).map(r => r.name);

    if (roleNames.includes(ADMIN_ROLE_NAME)) {
        if (!rmEnabled) {
            // can be removed once RM is released
            return [
                false,
                t('settings.licenseManagement.adminDeletionForbidden'),
            ] as [false, string];
        }
        if (u.userId === selfId || !selfId) {
            return [
                false,
                t('settings.licenseManagement.selfDeletionForbidden'),
            ] as [false, string];
        }
    }

    // can be removed once RM is released
    if (roleNames.includes(AUTHOR_ROLE_NAME) && !rmEnabled) {
        return [
            false,
            t('settings.licenseManagement.authorDeletionForbidden'),
        ] as [false, string];
    }
    return [true, null] as const;
};
